// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Float = require("rescript/lib/js/belt_Float.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ImportEnrichmentPatternCatalog$ReactHooksTemplate = require("./ImportEnrichmentPatternCatalog.res.js");

function decodeObject(json) {
  return Belt_Option.getWithDefault(Js_json.decodeObject(json), {});
}

function jsonToString(value) {
  var str = Js_json.classify(value);
  if (typeof str !== "object") {
    switch (str) {
      case "JSONFalse" :
          return "false";
      case "JSONTrue" :
          return "true";
      case "JSONNull" :
          return "";
      
    }
  } else {
    switch (str.TAG) {
      case "JSONString" :
          return str._0;
      case "JSONNumber" :
          return str._0.toString();
      case "JSONObject" :
      case "JSONArray" :
          return Belt_Option.getWithDefault(JSON.stringify(value), "");
      
    }
  }
}

function resolvePathFromRoot(root, path) {
  var segments = Js_string.split(".", path);
  if (segments.length === 0) {
    return ;
  }
  var start = Js_dict.get(root, Belt_Array.getExn(segments, 0));
  if (start !== undefined) {
    var _current = start;
    var _segmentIndex = 1;
    while(true) {
      var segmentIndex = _segmentIndex;
      var current = _current;
      if (segmentIndex >= segments.length) {
        var match = Js_json.classify(current);
        if (typeof match !== "object" && match === "JSONNull") {
          return ;
        } else {
          return jsonToString(current);
        }
      }
      var obj = Js_json.decodeObject(current);
      if (obj === undefined) {
        return ;
      }
      var segment = Belt_Array.get(segments, segmentIndex);
      if (segment === undefined) {
        return ;
      }
      var next = Js_dict.get(obj, segment);
      if (next === undefined) {
        return ;
      }
      _segmentIndex = segmentIndex + 1 | 0;
      _current = next;
      continue ;
    };
  }
  
}

function buildPreviewRoot(payloadJson, contextJson) {
  var payload = decodeObject(payloadJson);
  var context = decodeObject(contextJson);
  var root = {};
  var v = Js_dict.get(payload, "customer_details_data");
  if (v !== undefined) {
    root["customer_details_data"] = v;
  } else {
    root["customer_details_data"] = {};
  }
  var v$1 = Js_dict.get(payload, "more_details");
  if (v$1 !== undefined) {
    root["more_details"] = v$1;
  } else {
    root["more_details"] = {};
  }
  root["context"] = context;
  return root;
}

function resolveSampleValue(payloadJson, contextJson, path) {
  var root = buildPreviewRoot(payloadJson, contextJson);
  return resolvePathFromRoot(root, path);
}

function makeRegex(pattern, caseSensitive) {
  if (pattern.trim() === "" || pattern.length > 200) {
    return ;
  }
  try {
    var flags = caseSensitive ? "" : "i";
    return Caml_option.some(new RegExp(pattern, flags));
  }
  catch (exn){
    return ;
  }
}

function testCondition(op, value, pattern, format, caseSensitive, sample) {
  if (sample === undefined) {
    return "NoSample";
  }
  if (sample === "" && op !== "blank" && op !== "present") {
    return "EmptyField";
  }
  var left = sample.toLowerCase();
  var matched;
  var exit = 0;
  switch (op) {
    case "blank" :
        matched = sample.trim() === "";
        break;
    case "contains" :
        matched = left.includes(value.toLowerCase());
        break;
    case "ends_with" :
        matched = left.endsWith(value.toLowerCase());
        break;
    case "eq" :
        matched = left === value.toLowerCase();
        break;
    case "in_list" :
        matched = Belt_Array.some(Belt_Array.keep(Belt_Array.map(Js_string.split(value, ","), (function (v) {
                        return v.trim().toLowerCase();
                      })), (function (v) {
                    return v !== "";
                  })), (function (v) {
                return v === left;
              }));
        break;
    case "gt" :
    case "gte" :
    case "lt" :
    case "lte" :
        exit = 1;
        break;
    case "matches_format" :
        var re = makeRegex(ImportEnrichmentPatternCatalog$ReactHooksTemplate.regexForFormat(format), false);
        matched = re !== undefined ? Caml_option.valFromOption(re).test(sample) : false;
        break;
    case "neq" :
        matched = left !== value.toLowerCase();
        break;
    case "not_contains" :
        matched = !left.includes(value.toLowerCase());
        break;
    case "present" :
        matched = sample.trim() !== "";
        break;
    case "regex_match" :
        var re$1 = makeRegex(pattern, caseSensitive);
        matched = re$1 !== undefined ? Caml_option.valFromOption(re$1).test(sample) : false;
        break;
    case "starts_with" :
        matched = left.startsWith(value.toLowerCase());
        break;
    default:
      matched = false;
  }
  if (exit === 1) {
    var match = Belt_Float.fromString(sample);
    var match$1 = Belt_Float.fromString(value);
    if (match !== undefined && match$1 !== undefined) {
      switch (op) {
        case "gt" :
            matched = match > match$1;
            break;
        case "gte" :
            matched = match >= match$1;
            break;
        case "lt" :
            matched = match < match$1;
            break;
        case "lte" :
            matched = match <= match$1;
            break;
        default:
          matched = false;
      }
    } else {
      matched = false;
    }
  }
  if (matched) {
    return "Matched";
  } else {
    return "NotMatched";
  }
}

function testResultLabel(result) {
  switch (result) {
    case "NoSample" :
        return "Add a value for this field in Simulation Lab to test.";
    case "EmptyField" :
        return "Field is empty in sample.";
    case "Matched" :
        return "Matches sample value";
    case "NotMatched" :
        return "Does not match sample value";
    
  }
}

function testResultClass(result) {
  switch (result) {
    case "NoSample" :
    case "EmptyField" :
        return "text-gray-500";
    case "Matched" :
        return "text-green-600";
    case "NotMatched" :
        return "text-red-600";
    
  }
}

var regexLengthLimit = 200;

exports.regexLengthLimit = regexLengthLimit;
exports.decodeObject = decodeObject;
exports.jsonToString = jsonToString;
exports.resolvePathFromRoot = resolvePathFromRoot;
exports.buildPreviewRoot = buildPreviewRoot;
exports.resolveSampleValue = resolveSampleValue;
exports.makeRegex = makeRegex;
exports.testCondition = testCondition;
exports.testResultLabel = testResultLabel;
exports.testResultClass = testResultClass;
/* No side effect */
